export const BaseAddress = () => import('../../components/BaseAddress.vue' /* webpackChunkName: "components/base-address" */).then(c => wrapFunctional(c.default || c))
export const BaseAlert = () => import('../../components/BaseAlert.vue' /* webpackChunkName: "components/base-alert" */).then(c => wrapFunctional(c.default || c))
export const BaseButton = () => import('../../components/BaseButton.vue' /* webpackChunkName: "components/base-button" */).then(c => wrapFunctional(c.default || c))
export const BaseConfirm = () => import('../../components/BaseConfirm.vue' /* webpackChunkName: "components/base-confirm" */).then(c => wrapFunctional(c.default || c))
export const BaseDropdown = () => import('../../components/BaseDropdown.vue' /* webpackChunkName: "components/base-dropdown" */).then(c => wrapFunctional(c.default || c))
export const BaseDropshippingPrice = () => import('../../components/BaseDropshippingPrice.vue' /* webpackChunkName: "components/base-dropshipping-price" */).then(c => wrapFunctional(c.default || c))
export const BaseImage = () => import('../../components/BaseImage.vue' /* webpackChunkName: "components/base-image" */).then(c => wrapFunctional(c.default || c))
export const BaseLink = () => import('../../components/BaseLink.vue' /* webpackChunkName: "components/base-link" */).then(c => wrapFunctional(c.default || c))
export const BaseMessages = () => import('../../components/BaseMessages.vue' /* webpackChunkName: "components/base-messages" */).then(c => wrapFunctional(c.default || c))
export const BaseModal = () => import('../../components/BaseModal.vue' /* webpackChunkName: "components/base-modal" */).then(c => wrapFunctional(c.default || c))
export const BaseTag = () => import('../../components/BaseTag.vue' /* webpackChunkName: "components/base-tag" */).then(c => wrapFunctional(c.default || c))
export const BaseToggle = () => import('../../components/BaseToggle.vue' /* webpackChunkName: "components/base-toggle" */).then(c => wrapFunctional(c.default || c))
export const BaseTooltip = () => import('../../components/BaseTooltip.vue' /* webpackChunkName: "components/base-tooltip" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
